import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import { UpdateRouteMapProps } from './types';
import { useGetOrderMissionQuery } from '@src/features/order/redux';
import { useParams } from 'react-router-dom';
import { MissionIdParams } from '@src/core/entities';
import { useDispatch } from 'react-redux';
import { setWaypoints } from '@src/features/order/pages/upsert-mission-page/redux';
import { RouteWaypointEntity, RouteWaypointType } from '@src/features/order/pages/upsert-mission-page/entities';
import { RouteWPS, TerrainAware } from '@src/features/order/pages/upsert-mission-page/components';
import { ArcStack } from '@src/core/ui';
import { DroneStatusType, useDroneProvider } from '@src/core/features';
import { ArcDroneMarker } from '@src/core/controllers';

const UpdateRouteMap: React.FC<UpdateRouteMapProps> = () => {
  const dispatch = useDispatch();
  const params = useParams<MissionIdParams>();
  const { data, isLoading } = useGetOrderMissionQuery(params.missionId);
  const { drones: idleDrones } = useDroneProvider(DroneStatusType.IDLE);

  React.useEffect(() => {
    if (!data) return;
    const size = data.waypoints.length;
    dispatch(setWaypoints(data.waypoints.map((w, idx) => {
      const updatedWp: RouteWaypointEntity = {
        uuid: uuidv4(),
        orderId: w.orderId,
        latitude: w.latitude,
        longitude: w.longitude,
        altitude: w.altitude,
        type: RouteWaypointType.WAYPOINT,
      };

      if (idx === 0 || idx === size -1) {
        return {
          ...updatedWp,
          type: RouteWaypointType.TAKE_OFF,
        };
      }
      
      if (w.orderId) {
        return {
          ...updatedWp,
          type: RouteWaypointType.DESTINATION,
        };
      }
      return updatedWp;
    })));
  }, [data]);

  if (isLoading) return null;

  return (
    <React.Fragment>
      {idleDrones.map((drone) => (
        <ArcDroneMarker.idleArrow 
          key={drone.id}
          position={{ 
            lat: Number(drone.latitude), 
            lng: Number(drone.longitude),
          }}  
        />
      ))}
      <RouteWPS />
      <ArcStack
        p={1}
        width='100%' 
        height={300} 
        zIndex={100}
        bottom={0}
        bgcolor='transparent'
        position='absolute'>
        <TerrainAware />
      </ArcStack>
    </React.Fragment>
  );
};

export default UpdateRouteMap;